import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Tabs, Tab } from '@common/components/tabs/tabs.component';
import { VendorViewModel } from '@models/Vendor';
import { GeneralInfo } from '../steps/general-info/general-info.container';
import { AddressNFinances } from '../steps/address-n-finances/address-n-finances.container';
import { CoverageNLimits } from '../steps/coverage-n-limits/coverage-n-limits.container';
import { VendorDefaultRatingsComponent } from './vendor-detault-ratings.component';
import { SpinnerPage, Breadcrumbs } from '@common/components';

export interface VendorEditComponentProps extends RouteComponentProps<{ id?: number }> {
  readonly currentFormState: Partial<VendorViewModel>;
  readonly isLoading: boolean;
  readonly vendor?: VendorViewModel;
  readonly saving?: boolean;
  readonly getVendorDetails: (id: number) => void;
  readonly saveAllTabs: (vendor?: VendorViewModel, updates?: Partial<VendorViewModel>) => void;
  readonly clearVendor: () => void;
  readonly checkIsTabValid: (fromTab: number) => boolean;
}

interface VendorEditState {
  isSaving: boolean;
  saveAttempted: boolean;
  allValid: boolean;
}

enum VENDOR_STEPS {
  GENERAL_INFO_STEP = 0,
  ADDRESS_FINANCE_STEP,
  COVERAGE_LIMITS_STEP,
  DEFAULT_RATINGS_STEP
}

export class VendorEditComponent extends React.Component<VendorEditComponentProps, VendorEditState> {
  private hiddenButtons: Array<HTMLButtonElement> = [];
  constructor(props: VendorEditComponentProps) {
    super(props);

    this.state = {
      isSaving: false,
      saveAttempted: false,
      allValid: false
    };
  }

  componentDidMount() {
    if ((this.props.match.params || {}).id) {
      this.props.getVendorDetails(this.props.match.params.id!);
    }
  }

  componentWillUnmount() {
    this.props.clearVendor();
  }

  getButtonRef = (step: number) => {
    return (button: HTMLButtonElement) => {
      this.hiddenButtons[step] = button;
    };
  };

  validate = (fromTabIndex: number) => {
    const button = this.hiddenButtons[fromTabIndex];
    if (button) {
      button.click();
    }
  };

  handleSaveClick = () => {
    if (!this.state.isSaving) {
      this.setState({ isSaving: true, saveAttempted: true });
      let anyInvalid = false;

      for (const key of Object.keys(this.hiddenButtons)) {
        this.validate(+key);
        if (!this.props.checkIsTabValid(+key)) {
          this.setState({
            allValid: false,
            isSaving: false
          });
          anyInvalid = true;
        }
      }

      if (!anyInvalid) {
        this.setState({ allValid: true });
        this.validateAndFinish();
      }
    }
  };

  validateAndFinish = () => {
    const checkIsTabValid = this.props.checkIsTabValid;
    this.setState(
      {
        allValid:
          checkIsTabValid(VENDOR_STEPS.GENERAL_INFO_STEP) &&
          checkIsTabValid(VENDOR_STEPS.ADDRESS_FINANCE_STEP) &&
          checkIsTabValid(VENDOR_STEPS.COVERAGE_LIMITS_STEP) &&
          checkIsTabValid(VENDOR_STEPS.DEFAULT_RATINGS_STEP),
        isSaving: true
      },

      this.finishSave
    );
  };

  finishSave = () => {
    if (this.state.isSaving && this.state.allValid) {
      if (this.props.vendor && this.props.currentFormState) {
        this.props.saveAllTabs(this.props.vendor, this.props.currentFormState);
      }
    } else {
      this.setState({ isSaving: false });
    }
  };

  render() {
    if (this.props.vendor && this.props.vendor.id && !this.props.isLoading) {
      return (
        <>
          <Breadcrumbs />
          <Tabs>
            <Tab
              title={'General Info'}
              showError={this.state.saveAttempted && !this.props.checkIsTabValid(VENDOR_STEPS.GENERAL_INFO_STEP)}
            >
              <GeneralInfo
                buttonRef={this.getButtonRef(VENDOR_STEPS.GENERAL_INFO_STEP)}
                currentStep={VENDOR_STEPS.GENERAL_INFO_STEP}
                isEdit={true}
              />
            </Tab>
            <Tab
              title={'Address & Finances'}
              showError={this.state.saveAttempted && !this.props.checkIsTabValid(VENDOR_STEPS.ADDRESS_FINANCE_STEP)}
            >
              <AddressNFinances
                buttonRef={this.getButtonRef(VENDOR_STEPS.ADDRESS_FINANCE_STEP)}
                currentStep={VENDOR_STEPS.ADDRESS_FINANCE_STEP}
                isEdit={true}
              />
            </Tab>
            <Tab
              title={'Coverage & Limits'}
              showError={this.state.saveAttempted && !this.props.checkIsTabValid(VENDOR_STEPS.COVERAGE_LIMITS_STEP)}
            >
              <CoverageNLimits
                buttonRef={this.getButtonRef(VENDOR_STEPS.COVERAGE_LIMITS_STEP)}
                currentStep={VENDOR_STEPS.COVERAGE_LIMITS_STEP}
              />
            </Tab>
            <Tab
              title={'Default Ratings'}
              showError={this.state.saveAttempted && !this.props.checkIsTabValid(VENDOR_STEPS.DEFAULT_RATINGS_STEP)}
            >
              <VendorDefaultRatingsComponent
                vendor={this.props.vendor}
                currentStep={VENDOR_STEPS.DEFAULT_RATINGS_STEP}
              />
            </Tab>
          </Tabs>
          <div className="row end-xs">
            <div className="col-xs-12">
              <button className="btn btn-secondary" type="button" onClick={() => window.history.back()}>
                Cancel
              </button>{' '}
              <button
                type="button"
                disabled={this.state.isSaving}
                className="btn btn-primary"
                onClick={this.handleSaveClick}
              >
                {this.props.saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        </>
      );
    }
    return <SpinnerPage />;
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/vendor-edit/vendor-edit.component.tsx